import * as React from "react";
const SvgArrowThick = ({
  title,
  titleId,
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 19" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M.51 17.59c.327.346.77.54 1.233.54.462 0 .905-.194 1.232-.54l6.823-7.228a1.9 1.9 0 0 0 .51-1.304 1.9 1.9 0 0 0-.51-1.305L2.972.53A1.673 1.673 0 0 0 .519.54a1.92 1.92 0 0 0-.008 2.597l5.592 5.921L.511 14.98A1.9 1.9 0 0 0 0 16.285c0 .49.184.959.51 1.304z" /></svg>;
export default SvgArrowThick;